/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import Tooltip from '@atlaskit/tooltip';
import { N300 } from '@atlaskit/theme/colors';
const wrapperStyles = css({
  display: 'flex',
  alignItems: 'center',
  marginRight: "var(--ds-space-050, 4px)"
});
const imgStyles = css({
  width: "var(--ds-space-100, 8px)",
  height: "var(--ds-space-100, 8px)"
});
const textStyles = css({
  fontSize: "var(--ds-space-150, 12px)",
  color: `${`var(--ds-text-subtlest, ${N300})`}`,
  marginRight: "var(--ds-space-050, 4px)",
  marginLeft: "var(--ds-space-025, 2px)"
});
export const Metadata = ({
  text,
  icon,
  iconUrl,
  tooltip
}) => {
  let metadataIcon = icon || null;
  if (!metadataIcon && iconUrl) {
    metadataIcon = jsx("img", {
      src: iconUrl,
      css: imgStyles
    });
  }
  const metadata = jsx("div", {
    css: wrapperStyles
  }, metadataIcon, jsx("span", {
    css: textStyles
  }, text));
  if (tooltip) {
    return jsx(Tooltip, {
      content: tooltip
    }, metadata);
  }
  return metadata;
};